import React, { Component } from "react";
import getObj from "lodash/get";
import { connect } from "react-redux";
import { Form, Input, InputNumber, Card, Button, Row, Col, message, Select, Empty, Descriptions, DatePicker, Cascader } from "antd";
import axios from "services/axios";
import moment from "moment";
import { getValue } from "../utils";

const Option = Select.Option;
const FormItem = Form.Item;
const { TextArea } = Input;
const formItemLayout = {
  labelCol: {
    xs: { span: 24 },
    sm: { span: 6 },
    md: { span: 8 },
  },
  wrapperCol: {
    xs: { span: 24 },
    sm: { span: 18 },
    md: { span: 16},
  },
};

class OfferingDetail extends Component {
  state = {
    cars: [],
    colors: [],
    loading: false
  };

  componentDidMount = async () => {
    try {
      const {
        match: { params },
        Car
      } = this.props;

      let { data: {kategori_warna} } = await axios.get("misc/colors");
      let { data: {branch_offices} } = await axios.get("misc/branch-offices");
      let request = await axios.get(`/car-inquiry/${params.id}`);
      await this.setState({
        ...request.data.inquiry,
        appraisal: request.data.appraisal,
        cars: Car.cars,
        colors: kategori_warna,
        branch_offices,
        supervisor: request.data.supervisor
      });

    } catch (err) {
      console.log(err.message);
    }
  };

  onClickDeal(deal) {
    const { bookingId, appraisal } = this.state;
    this.setState({loading: true})
    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log(values)
      if (err) {
        message.error("Failed confirmation deal");
      } else {
          appraisal.carDetail[7].value = values.licensePlate;
          appraisal.carSummary[this.getObjIdx("Kategori Warna", "carSummary")].value = values.color;
          appraisal.carSummary[this.getObjIdx("Kategori Warna", "carSummary")].code = values.color === "Putih" || values.color === "Hitam" ? "0" : "1";

          let payload = {
            // dealNotes: values.dealNotes,
            dealPrice: values.dealPrice,
            deal,
            bookingId,
            appraisal,
            branchOffice: values.branchOffice
          }
          console.log(payload)
          axios
            .put(`/car-inquiry/${this.props.match.params.id}/deal`, payload)
            .then(res => {
              if(!res.data.success) {
                message.error(`${res.data.error_message} from Odoo`);
              } else {
                message.success("Success Confirmation Deal");
              }
              this.setState({loading: false})
              this.props.history.push("/home/internal-bidding/deal-confirmation");
            })
            .catch(err => {
              console.log(err)
              message.error("Failed Confirmation Deal");
              this.props.history.push("/home/internal-bidding/deal-confirmation");
            });
      }
    });
  }

  onChangeCarDetail(type, value) {
    let appraisal = this.state.appraisal;
    if(type === "brand"){
      appraisal.carSummary[0].value = value[0]
      appraisal.carSummary[1].value = value[1]
      appraisal.carSummary[2].value = value[2]
    } else if(type === "Tahun") {
      let idx = this.getObjIdx(type, "carSummary");
      appraisal.carSummary[idx].value = value;
    } else if(type === "Tahun STNK" || type === "STNK 5 Tahunan" || type === "Pajak Satu Tahun") {
      let idx = this.getObjIdx(type,"carDetail")
      appraisal.carDetail[idx].value = moment(value).format("YYYY-MM-DD");
    } else if(type === "Jarak Tempuh") {
      let idx = this.getObjIdx(type,"carDetail")
      appraisal.carDetail[idx].value = value;
    }
    this.setState({ appraisal })
  }

  getObjIdx(fieldName, column) {
    let appraisal = this.state.appraisal;
    return appraisal[column].findIndex(obj => obj.fieldName === fieldName)
  } 
  render() {
    const { getFieldDecorator } = this.props.form;
    const { appraisal, Booking, cars, colors, branch_offices, branchOffice, supervisor} = this.state;
    return this.state.id ?(
      <Card>
        <Form layout="vertical">
          <Row gutter={16}>
            <Col xs={24} md={12}>
              <Descriptions size="small" title="Sales Informartion" column={1} bordered={true}>
                <Descriptions.Item label="Nama Sales">  {getObj(Booking, "SalesProfile.name")} </Descriptions.Item>
                <Descriptions.Item label="Nama Cabang"> {getObj(Booking, "SalesProfile.branch")} </Descriptions.Item>
                <Descriptions.Item label="No. Hp"> {getObj(Booking, "SalesProfile.phone")} </Descriptions.Item>
                <Descriptions.Item label="Nama SS"> {supervisor ? supervisor.name : ""} </Descriptions.Item>
              </Descriptions>
            </Col>
            <Col xs={24} md={12}>
              <Descriptions size="small" title="Customer Information" column={1} bordered={true} style={{marginTop: 10}}>
                {["carDetail[0]", "carDetail[2]", "carDetail[1]"].map((field, index) => (
                  <Descriptions.Item key={index} label={getObj(appraisal, field).fieldName}>
                    {getObj(appraisal, field).value}
                  </Descriptions.Item>
                ))}
              </Descriptions>
            </Col>
          </Row>

          <Card title="Car Information" style={{ marginTop: "30px" }}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormItem label="Nomor Polisi" {...formItemLayout}>
                  {getFieldDecorator("licensePlate", {
                    initialValue: getObj(appraisal, "carDetail[7]").value,
                    rules:[{require: true, message: "Nomor polisi wajib diisi"}]
                  })(
                    <Input
                      style={{ width: "100%" }}
                      placeholder="Plat Nomor"
                    />,
                  )}
                </FormItem>
                <Form.Item label="Tipe Mobil"  {...formItemLayout}>
                  <Cascader
                    defaultValue={[
                      getObj(appraisal, "carSummary[0]").value,
                      getObj(appraisal, "carSummary[1]").value,
                      getObj(appraisal, "carSummary[2]").value,
                    ]}
                    fieldNames={{ label: 'value', value: 'id', children: 'items' }}
                    options={cars}
                    onChange={(value)=> this.onChangeCarDetail("brand", value)}
                  />
                </Form.Item>
                {
                  getObj(appraisal, "carDetail[3]").value !== "" 
                  ? 
                    <FormItem label="Mobil (Data Lama)" {...formItemLayout}>
                      {getFieldDecorator("oldDataCar", {
                        initialValue: [
                          getObj(appraisal, "carDetail[3]").value,
                          getObj(appraisal, "carDetail[4]").value,
                          getObj(appraisal, "carDetail[5]").value,
                        ].join(" ")
                      })(
                        <TextArea
                          disabled
                        />,
                      )}
                    </FormItem>
                  : null
                }
                <FormItem label="Jarak Tempuh" {...formItemLayout}>
                  <InputNumber 
                    defaultValue={getObj(appraisal, "carDetail[11]").value} 
                    style={{ width: "100%" }} 
                    onChange={(value) => this.onChangeCarDetail("Jarak Tempuh", value)}
                  />
                </FormItem>
                <FormItem label="Warna Eksterior" {...formItemLayout}>
                  {getFieldDecorator("color", {
                    rules:[{require: true, message: "Warna eksterior mobil wajib diisi"}],
                    initialValue: getValue(appraisal.carSummary, "Kategori Warna")
                  })(
                    <Select>
                      {
                        colors.map((color, idx) => (
                        <Option key={idx} value={color.id}>{color.label}</Option>
                        ))
                      }
                    </Select>,
                  )}
                </FormItem>
                {getObj(appraisal, "carDetail[10]").value
                  ? 
                    <FormItem label="Warna Eksterior (Data Lama)" {...formItemLayout}>
                      {getFieldDecorator("oldColor", {
                        initialValue: getObj(appraisal, "carDetail[10]").value,
                      })(
                        <Input
                          disabled
                          style={{ width: "100%" }}
                        />,
                      )}
                    </FormItem>
                  : null}
              </Col>
              <Col xs={24} md={12}>
                <FormItem label="Tahun" {...formItemLayout}>
                  <InputNumber 
                    defaultValue={getValue(appraisal.carSummary, "Tahun")} 
                    min={2001} 
                    style={{ width: "100%" }}
                    onChange={value => this.onChangeCarDetail("Tahun", value)}
                  />
                </FormItem>

                {getValue(appraisal.carDetail, "Tahun") !== ""
                  ? 
                    <FormItem label="Tahun (Data Lama)" {...formItemLayout}>
                      {getFieldDecorator("oldYear", {
                        initialValue: getValue(appraisal.carDetail, "Tahun"),
                      })(
                        <InputNumber
                          min={2001}
                          disabled
                          style={{ width: "100%" }}
                        />,
                      )}
                    </FormItem>
                  : null}
                {getObj(appraisal, "carDetail[12]").fieldName == "Tahun STNK" 
                  ?
                    <Form.Item label="Tahun STNK" {...formItemLayout} rules={[{ required: true, message: 'Tahun STNK Wajib diisi' }]}>
                      <DatePicker 
                        style={{ width: "100%" }}
                        defaultValue={moment(getObj(appraisal, "carDetail[12]").value)}
                        onChange={(dateVal) => this.onChangeCarDetail("Tahun STNK", dateVal)}
                      />
                    </Form.Item>
                    :
                    <Form.Item label="Pajak Satu Tahun" {...formItemLayout} rules={[{ required: true, message: 'Pajak Satu Tahun Wajib diisi' }]}>
                      <DatePicker 
                        style={{ width: "100%" }}
                        defaultValue={moment(getObj(appraisal, "carDetail[12]").value)}
                        onChange={(dateVal) => this.onChangeCarDetail("Pajak Satu Tahun", dateVal)}
                      />
                    </Form.Item>
                }
                {getValue(appraisal.carDetail, "STNK 5 Tahunan") !== ""
                  ? 
                    <Form.Item label="STNK 5 Tahunan" {...formItemLayout} rules={[{ required: true, message: 'STNK 5 Tahunan Wajib diisi' }]}>
                      <DatePicker 
                        style={{ width: "100%" }}
                        defaultValue={moment(getObj(appraisal, "carDetail[13]").value)}
                        onChange={(dateVal) => this.onChangeCarDetail("STNK 5 Tahunan", dateVal)}
                      />
                    </Form.Item>
                  : null }
                <FormItem label="Lokasi Penyimpanan Mobil" {...formItemLayout}>
                  {getFieldDecorator("branchOffice", {
                    rules:[{require: true, message: "Lokasi Cabang penyimpanan mobil wajib diisi"}],
                    initialValue: branchOffice
                  })(
                    <Select>
                      {
                        branch_offices.map((color, idx) => (
                        <Option key={idx} value={color.id}>{color.label}</Option>
                        ))
                      }
                    </Select>,
                  )}
                </FormItem>
              </Col>
            </Row>
          </Card>

          <Card title="Negotiation Form" style={{ marginTop: "30px" }}>
            <Row gutter={16}>
              <Col xs={24} md={12}>
                <FormItem label="Harga Nett" {...formItemLayout}>
                  {getFieldDecorator("priceNegotiation", {
                    initialValue: this.state.negotiationPrice,
                  })(
                    <InputNumber
                      disabled={true}
                      style={{ width: "100%" }}
                      formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                    />,
                  )}
                </FormItem>
                <FormItem label="Harga Nego" {...formItemLayout}>
                  {getFieldDecorator("priceFromNegotiator", {
                    initialValue: this.state.priceFromNegotiator,
                  })(
                    <InputNumber
                      disabled={true}
                      style={{ width: "100%" }}
                      formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                    />,
                  )}
                </FormItem>
                <FormItem label="Harga Final" {...formItemLayout}>
                  {getFieldDecorator("dealPrice", {
                    initialValue: this.state.dealPrice || 0,
                  })(
                    <InputNumber
                      style={{ width: "100%" }}
                      formatter={value => `IDR ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                      parser={value => value.replace(/IDR\s?|(,*)/g, "")}
                      disabled={this.state.status !== "DEAL_CONFIRMATION"}
                    />,
                  )}
                </FormItem>
              </Col>
            </Row>

            <Row style={{ float: "right" }}>
              <Col span={24}>
                <Button loading={this.state.loading} onClick={() => this.onClickDeal(false)} key="nodeal" type="danger" htmlType="button">
                  NO DEAL
                </Button>
                &nbsp;
                <Button loading={this.state.loading} onClick={() => this.onClickDeal(true)} key="deal" type="primary" htmlType="button">
                  DEAL
                </Button>
              </Col>
            </Row>
          </Card>
        </Form>
      </Card>
    ) : (<Empty/>) ;
  }
}

const FormOffering = Form.create()(OfferingDetail);
const mapStateToProps = ({ Auth, Car }) => ({ Auth, Car });

export default connect(mapStateToProps)(FormOffering);



// WEBPACK FOOTER //
// src/components/Dashboard/InternalBidding/DealConfirmation/DealConfirmationUpdate.js